<template>
  <form @submit.prevent="">
    <div class="form-group">
      <label for="mealTitle">
        {{ $t('shop.deliveryPlan.mealTitle') }}
      </label>
      <input
        id="mealTitle"
        v-model="name"
        type="text"
        class="form-control"
        :placeholder="$t('shop.deliveryPlan.mealTitle')"
        required
      >
    </div>

    <div>
      <div
        v-for="diet in diets"
        :key="diet.nodeId"
        class="diet-row"
        :class="{ enabled: dietsEnabled[diet.nodeId] }"
      >
        <div class="d-flex align-items-center my-1">
          <BFormCheckbox
            v-model="dietsEnabled[diet.nodeId]"
            switch
            class="switch white-switch white-switch-sm"
          />
          <label>
            {{ diet.name }}
          </label>
        </div>

        <IngredientSearch
          v-if="dietsEnabled[diet.nodeId]"
          class="mt-2"
          :ingredients="ingredients"
          :diet-id="diet.nodeId"
          :init-ingredients="meal?.ingredients?.filter((e) => e.dietId === diet.nodeId) || []"
          :meal-sizes="mealSizes"
          @ingredients="dietIngredients[diet.nodeId] = $event"
        />
      </div>
    </div>
  </form>
</template>

<script>
import axios from '@/api/axios';
import { mapGetters } from 'vuex';
import IngredientSearch from './IngredientSearch';

export default {
  props: {
    meal: {
      type: Object,
      required: false,
    },
    ingredients: {
      type: Array,
      required: false,
    },
    mealSizes: {
      type: Array,
      required: false,
    },
  },
  data: () => ({
    name: '',
    dietsEnabled: {},
    dietIngredients: {},
  }),
  components: {
    IngredientSearch,
  },
  computed: {
    ...mapGetters('shop', ['catalogDetails']),
    diets() {
      return this.catalogDetails.subCatalogNodes
        .filter((x) => x.subCatalogId === this.catalogDetails.metadata.dietId);
    },
  },
  methods: {
    saveMeal() {
      if (this.meal) {
        axios.put(`shop/${this.catalogDetails.id}/meals/${this.meal.id}`, {
          name: this.name,
          ingredients: Object.values(this.dietIngredients).flat()
            .filter((x) => this.dietsEnabled[x.dietId])
            .filter((x) => x.count > 0 || x.weight > 0),
        })
          .then(() => {
            this.$emit('saved');
          });
      } else {
        axios.post(`shop/${this.catalogDetails.id}/meals`, {
          name: this.name,
          ingredients: Object.values(this.dietIngredients).flat()
            .filter((x) => this.dietsEnabled[x.dietId])
            .filter((x) => x.count > 0 || x.weight > 0),
        })
          .then(() => {
            this.$emit('saved');
          });
      }
    },
  },
  created() {
    if (this.meal) {
      this.name = this.meal.name;
      this.dietsEnabled = this.meal.ingredients.reduce((acc, diet) => {
        acc[diet.dietId] = true;
        return acc;
      }, {});
    }
  },
};
</script>

<style lang="scss" scoped>
.diet-row {
  padding: 5px 10px;
  margin-top: 4px;

  label {
    margin-bottom: 0;
  }

  &:hover {
    background-color: #f0f0f0;
  }

  transition: all 0.3s ease;

  &.enabled {
    background-color: rgba($blue, 0.1);
    padding-bottom: 20px;
    padding-top: 10px;
  }
}
</style>
